import { render, staticRenderFns } from "./HeroLogo.vue?vue&type=template&id=6f54bffb&"
import script from "./HeroLogo.vue?vue&type=script&lang=js&"
export * from "./HeroLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports